export default __webpack_public_path__ + "static/media/02__o_preview_0.df475d71.jpg";